<template>
  <div class="line">
    <div class="line-box clear">
      <div v-for="(line, index) in lineList" :key="index" class="line-item-box  clear">
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont-box">
              <div class="line-cont">
                <div class="v-line-desc text-overflow">
                  {{ item.desc }}
                </div>
              </div>
              <div v-maidian="'line_'+index" class="line-btm clear">
                <div class="price">
                  <span class="price-span">{{
                    discount ? item.price * 0.8 : item.price
                  }}</span>
                  <mt-button
                    @click="jumpToSight(item.linkId)"
                    size="small"
                    >马上出发</mt-button
                  >
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              "https://imgs.qunarzz.com/vs_ceph_vs_tts/d09cf703-95ef-4be9-b63a-435bce73a07b.jpg_r_390x260x95_2f05054c.jpg",

            tagList: ["海鲜自助", "海岛游"],
            price: 2679,
            desc: "【跟团游】100%深度纯玩6日游//夜游上海乌镇西栅杭州西湖横店千岛湖苏州拙政园虎丘",
            linkId: "https://hwgl8.package.qunar.com/user/detail.jsp?id=1894815131&",
            discountId: "3401723685",
          },
          {
            headImg:
              "https://imgs.qunarzz.com/p/p95/201302/28/27304400bbf307fc93835fbb.jpg_r_390x260x95_2ea104c3.jpg",
            tagList: ["雪山温泉", "草原"],
            price: 1980,
            desc: "【自由行】精品小团 住五星京泰龙国际酒店 轻奢北京紫禁城5日 游故宫恭王府颐和园",
            linkId: "https://bxwa1.package.qunar.com/user/detail.jsp?id=3001550252&",
            discountId: "1534603695",
          },
        ],
        [
          {
            headImg:
              "https://imgs.qunarzz.com/vs_ceph_b2c_001/0400e9a1-ba11-4b1e-84e9-2dfb3fd36757.jpg_r_390x260x95_a5107426.jpg",
            tagList: ["网红打卡", "自驾游"],
            price: 2928,
            desc: "【跟团游】机票+三冠8年店👏九寨沟+黄龙+熊猫+峨眉+乐山+青城山+都江堰8日潮流嗨玩7大核心丨全程贵宾高档四钻酒店丨座驾2+1保姆车 ",
            linkId: "https://hofd3.package.qunar.com/user/detail.jsp?id=3375773480&",
            discountId: "4078494581",
          },
          {
            headImg:
              "https://imgs.qunarzz.com/vs_ceph_b2c_001/d75519cd-ae8c-4cd7-a786-86cc8e4ae944.jpg_r_390x260x95_d9a276d6.jpg",
            tagList: ["熊猫基地", "探秘"],
            price: 1392,
            desc: "【自由行】机票+上海3天2晚自由行 赠迪士尼门票接送+打卡野生动物园 连住麦新格亲子酒店",
            linkId: "https://yhlx6.package.qunar.com/user/detail.jsp?id=1257978393&",
            discountId: "2625878855",
          },
        ]
      ],
    };
  },
  methods:{
    jumpToSight(linkId){
      window.location.href = linkId
    }
  }
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  top: -36px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  .line-cont-box{
    background: linear-gradient(-59deg, #FF9D4F 0%, #FDC701 99%);
  }
  &-box {
    margin-top: 10px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 163px;
    background-color: #fff;
    margin-bottom: 20px;
    float: left;
    z-index:2;
    &-box{
        position: relative;
        .bg-line {
            background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
                no-repeat;
            background-size: 100% auto;
            height: 20px;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 7px;
        }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #fff;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    color:#fff;
  }
  &-btm {
    padding: 7px;
    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 19px;
        color: #fff;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: "￥";
          font-size: 11px;
          position: relative;
        }
        &:after {
          content: "起";
          font-size: 11px;
          position: relative;
        }
      }
      button {
        position: relative;
        margin-right:0 !important;
      }
    }
  }
  &-head {
    img {
      display: block;
      height:122px;
    }
  }
  /deep/ .mint-button--small {
    border-radius: 10px !important;
    background-color: #Fff;
    border-radius: 6px;
    color: #F98704;
    font-size: 13px;
    height: 24px;
    margin-left: auto;
    margin-right: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
</style>